import { translate } from '../../../Internationalization';
import Pagination from '../../../../shared/Pagination';
import paths from '../../../../config/local/paths';
import React, { useEffect, useState } from 'react';
import useGetAdminVendors from '../../../../Hooks/Admin/Getters/useGetAdminVendors/useGetAdminVendors';
import useAuth from '../../../../Hooks/Shared/useAuth/useAuth';
import VendorsTable from '../../../shared/Vendors/VendorsTable/VendorsTable';
import useIsGated from '../../../../Hooks/Shared/useIsGated/useIsGated';
import flags from '../../../../shared/Flags';
import GenericAdminVendors from './GenericAdminVendors';

/**
 * @param {{mode: "agent" | "group" | "tenant" | "local"; isGated?: boolean; onTotalChange?: (total:number)=>void}} props
 * @returns {JSX.Element}
 */
export default function AdminVendors(props) {
	const auth = useAuth();
	const isOwnerOrAdmin =
		auth.roles.includes('owner') || auth.roles.includes('admin');
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const gated = useIsGated(flags.vendor.add, { role: 'admin' });
	const isGated = isOwnerOrAdmin ? false : gated.isGated;
	const vendors = useGetAdminVendors(props.mode, currentPageNumber, isGated);

	useEffect(() => {
		setCurrentPageNumber(1);
	}, [props.mode]);

	useEffect(() => {
		if (typeof props.onTotalChange === 'function') {
			props.onTotalChange(vendors.total ?? 0);
		}
	}, [props.onTotalChange, vendors.total]);

	if (isGated) {
		return <GenericAdminVendors />;
	}

	return (
		<React.Fragment>
			<VendorsTable
				editPath={paths.app.admin.offers.edit}
				editState={{ vendorMode: props.mode }}
				emptyMessage={translate(
					'admin.pages.offers.view.empty_message'
				)}
				emptyTitle={translate('admin.pages.offers.view.empty_title')}
				isGettingData={vendors.isGettingData}
				vendors={vendors.data}
			/>

			<Pagination
				currentPageNumber={currentPageNumber}
				lastPageNumber={vendors.lastPageNumber}
				setCurrentPageNumber={setCurrentPageNumber}
			/>
		</React.Fragment>
	);
}
